import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCashRegister, faClock, faUsers, faPlus, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useCaja } from './CajaContext';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moneda from '../moneda';
import storage from '../storage';
import baseURL from '../url';
import { ruta } from '../paths';

export default function ElegirCajaModal({ onAbrirNueva }) {
    const { cajasAbiertas, unirseCaja } = useCaja();
    const [uniendo, setUniendo] = useState(null);

    const fmt = (n) => Number(n || 0).toLocaleString('es-CO');
    const formatTiempo = (segs) => {
        const h = Math.floor(segs / 3600);
        const m = Math.floor((segs % 3600) / 60);
        return `${h}h ${m}m`;
    };

    const handleUnirse = async (idCaja) => {
        setUniendo(idCaja);
        const res = await unirseCaja(idCaja);
        setUniendo(null);
        if (res?.error) {
            toast.error(res.error);
        } else {
            toast.success(res.mensaje || 'Te uniste a la caja');
        }
    };

    const handleLogout = async () => {
        try {
            await fetch(`${baseURL}/logout.php`, { method: 'GET' });
        } catch (err) {
            // ignorar errores de red
        }
        storage.removeItem('adminUser');
        window.location.href = ruta('/');
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15, 20, 35, 0.95)', zIndex: 99998, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
            <ToastContainer />
            <div style={{ background: '#fff', borderRadius: '14px', padding: '28px', maxWidth: '460px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.5)', maxHeight: '90vh', overflowY: 'auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                    <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: '#e7f7ee', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <FontAwesomeIcon icon={faCashRegister} style={{ fontSize: '32px', color: '#28a745' }} />
                    </div>
                    <h2 style={{ margin: '0 0 8px', fontSize: '22px', color: '#212529' }}>Hay cajas abiertas</h2>
                    <p style={{ color: '#6c757d', fontSize: '14px', margin: 0 }}>
                        Elegí trabajar en una caja abierta o abrí una nueva.
                    </p>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {cajasAbiertas.map(c => (
                        <div key={c.idCaja} style={{ border: '1px solid #e9ecef', borderRadius: '10px', padding: '12px', background: '#f8f9fa' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                <strong style={{ color: '#212529' }}>Caja de {c.nombreTrabajador || '—'}</strong>
                                <span style={{ fontSize: '12px', color: '#6c757d' }}>
                                    <FontAwesomeIcon icon={faClock} /> {formatTiempo(c.segundosAbierta)}
                                </span>
                            </div>
                            <div style={{ fontSize: '13px', color: '#495057', marginBottom: '10px' }}>
                                <div>Inicial: <strong>{moneda} {fmt(c.montoInicial)}</strong></div>
                                <div>
                                    <FontAwesomeIcon icon={faUsers} /> {c.totalMiembros} {c.totalMiembros === 1 ? 'persona' : 'personas'} en la caja
                                </div>
                            </div>
                            <button
                                onClick={() => handleUnirse(c.idCaja)}
                                disabled={uniendo === c.idCaja}
                                style={{ width: '100%', padding: '10px', background: '#28a745', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 700, cursor: 'pointer' }}
                            >
                                {uniendo === c.idCaja ? 'Uniéndote...' : 'Unirme a esta caja'}
                            </button>
                        </div>
                    ))}
                </div>

                <button
                    onClick={onAbrirNueva}
                    style={{ width: '100%', marginTop: '16px', padding: '12px', background: 'var(--color1)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 700, cursor: 'pointer' }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Abrir una caja nueva
                </button>

                <button
                    onClick={handleLogout}
                    style={{ width: '100%', marginTop: '10px', padding: '10px', background: 'transparent', color: '#dc3545', border: '1.5px solid #dc3545', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
                >
                    <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión
                </button>
            </div>
        </div>
    );
}
